export default {
  'pages.flexibleSingleImport.title': '复杂单曲销售表格导入',
  'pages.flexibleSingleImport.info.message': '新导入链路',
  'pages.flexibleSingleImport.info.description':
    '文件会先暂存，逐个确认子表是否导入、表头和字段；不会调用现有上传接口。',
  'pages.flexibleSingleImport.upload.button': '选择并配置表格',
  'pages.flexibleSingleImport.upload.failed': '文件上传失败',
  'pages.flexibleSingleImport.upload.staged': '文件已暂存，请逐个确认子表的导入设置和字段',
  'pages.flexibleSingleImport.modal.title': '导入配置：{fileName}',
  'pages.flexibleSingleImport.modal.titleFallback': '导入配置',
  'pages.flexibleSingleImport.step.sheets': '选择子表和数据区',
  'pages.flexibleSingleImport.step.mapping': '字段对齐',
  'pages.flexibleSingleImport.step.sheetWizard': '逐个处理子表',
  'pages.flexibleSingleImport.step.preview': '预览校验',
  'pages.flexibleSingleImport.step.result': '执行结果',
  'pages.flexibleSingleImport.sheet.export': '导出',
  'pages.flexibleSingleImport.sheet.exportCurrent': '导出这个子表',
  'pages.flexibleSingleImport.sheet.headerAction': '表头操作',
  'pages.flexibleSingleImport.sheet.currentHeader': '当前表头',
  'pages.flexibleSingleImport.sheet.useAsHeader': '设为表头',
  'pages.flexibleSingleImport.sheet.importStepTitle': '第一步 · 决定是否导入这个子表',
  'pages.flexibleSingleImport.sheet.exportStepTitle': '第一步 · 确认是否导出这个子表',
  'pages.flexibleSingleImport.sheet.exportOnDescription':
    '已打开导出。确认后，这个子表会参与版税统计。',
  'pages.flexibleSingleImport.sheet.exportOffDescription':
    '当前关闭导出。请先查看内容，如果需要统计，再打开右侧拨杆。',
  'pages.flexibleSingleImport.sheet.exportOn': '导出这个子表',
  'pages.flexibleSingleImport.sheet.exportOff': '不导出',
  'pages.flexibleSingleImport.sheet.exportSwitch': '导出',
  'pages.flexibleSingleImport.sheet.skip': '跳过',
  'pages.flexibleSingleImport.sheet.tableTitle': '子表内容和字段对齐',
  'pages.flexibleSingleImport.sheet.dataRule':
    '数据从选定表头的下一行开始，自动读取到最后一个非空行。',
  'pages.flexibleSingleImport.sheet.chooseHeaderFirst': '请先选择包含真实列名的表头行。',
  'pages.flexibleSingleImport.sheet.exportMessage': '这个子表会在确认后参与校验和版税统计。',
  'pages.flexibleSingleImport.sheet.excludedMessage':
    '这个子表当前不导出；你仍可以继续查看，并随时打开导出拨杆。',
  'pages.flexibleSingleImport.sheet.navigationDescription':
    '按下面四个步骤处理：先决定是否导出，再选择表头并对应字段，然后检查已排除的行，最后补齐未对应的必填字段。',
  'pages.flexibleSingleImport.sheet.previewStepTitle': '第一步 · 先查看前几行数据',
  'pages.flexibleSingleImport.sheet.previewStepDescription':
    '确认这个子表是否是要统计的明细表，再决定导入还是不导入。',
  'pages.flexibleSingleImport.sheet.importMessage': '请查看样例，然后决定是否导入这个子表。',
  'pages.flexibleSingleImport.sheet.notImportMessage':
    '当前选择不导入这个子表，可以点击下方按钮继续。',
  'pages.flexibleSingleImport.sheet.completedImport': '第一步已完成：已选择导入这个子表',
  'pages.flexibleSingleImport.sheet.completedMapping':
    '第二步已完成：第 {row} 行为表头，已对应 {count} 个字段',
  'pages.flexibleSingleImport.sheet.completedExcluded': '第三步已完成：已排除 {count} 行',
  'pages.flexibleSingleImport.sheet.currentStep': '当前步骤：{step} / 4',
  'pages.flexibleSingleImport.sheet.mappingStepTitle': '第二步 · 找准表头并对应统计字段',
  'pages.flexibleSingleImport.sheet.skipMappingMessage': '这个子表不导出，可以跳过表头和字段对应。',
  'pages.flexibleSingleImport.sheet.skipMappingDescription':
    '如果这个子表需要参与版税统计，请先打开上面的导出拨杆。',
  'pages.flexibleSingleImport.sheet.summaryTitle': '已排除的行',
  'pages.flexibleSingleImport.sheet.filterTitle': '排除规则',
  'pages.flexibleSingleImport.sheet.excludedStepTitle': '第三步 · 检查已经排除的行',
  'pages.flexibleSingleImport.sheet.excludedStepDescription':
    '这些行不会导出参与统计。如果某一行其实是明细记录，可以取消勾选恢复。',
  'pages.flexibleSingleImport.sheet.noSummaryRows': '当前没有已排除的行。',
  'pages.flexibleSingleImport.sheet.excludeHint':
    '已排除的行会显示在上面的检查区域中，可以随时恢复。',
  'pages.flexibleSingleImport.sheet.reviewProgress': '已查看 {current} / {total} 个子表',
  'pages.flexibleSingleImport.sheet.status': '确认状态',
  'pages.flexibleSingleImport.sheet.selected': '已选择',
  'pages.flexibleSingleImport.sheet.pending': '待确认',
  'pages.flexibleSingleImport.sheet.name': '子表名称',
  'pages.flexibleSingleImport.sheet.nonEmptyRows': '非空行',
  'pages.flexibleSingleImport.sheet.columns': '列数',
  'pages.flexibleSingleImport.sheet.recommendation': '建议',
  'pages.flexibleSingleImport.sheet.recommendedDetail': '建议明细表',
  'pages.flexibleSingleImport.sheet.recommendedSummary': '建议汇总表',
  'pages.flexibleSingleImport.sheet.suspiciousRows': '已排除的行',
  'pages.flexibleSingleImport.sheet.validRows': '有效数据行',
  'pages.flexibleSingleImport.sheet.pendingPreview': '待预览',
  'pages.flexibleSingleImport.sheet.excludedRows': '当前排除行',
  'pages.flexibleSingleImport.sheet.configure': '配置',
  'pages.flexibleSingleImport.sheet.viewAdjust': '查看/调整',
  'pages.flexibleSingleImport.sheet.selectionTitle': '请明确选择要导入的子表',
  'pages.flexibleSingleImport.sheet.selectionDescription':
    '系统不会根据第一个子表、子表名称或历史样例自动决定导出范围。请逐个确认是否导出。',
  'pages.flexibleSingleImport.sheet.selectAll': '全部导出',
  'pages.flexibleSingleImport.sheet.clearAll': '全部取消',
  'pages.flexibleSingleImport.sheet.selectedCount': '已选择导出 {selected} / {total} 个子表',
  'pages.flexibleSingleImport.sheet.selectAtLeastOne': '请至少选择一个要导出的子表',
  'pages.flexibleSingleImport.dataArea.title': '数据区',
  'pages.flexibleSingleImport.dataArea.headerRow': '表头行',
  'pages.flexibleSingleImport.dataArea.startRow': '数据起始行',
  'pages.flexibleSingleImport.dataArea.endRow': '数据结束行',
  'pages.flexibleSingleImport.dataArea.autoSummary': '自动排除汇总行',
  'pages.flexibleSingleImport.filter.keywords': '关键词（逗号分隔）',
  'pages.flexibleSingleImport.filter.keywordsPlaceholder': '关键词：total、subtotal、合计……',
  'pages.flexibleSingleImport.filter.ignoredRows': '手动忽略行号（逗号分隔）',
  'pages.flexibleSingleImport.filter.ignoredRanges': '忽略行范围（例如 100-105, 210-212）',
  'pages.flexibleSingleImport.filter.ignoredRangesPlaceholder': '留空表示不按范围忽略',
  'pages.flexibleSingleImport.filter.checkColumns': '汇总关键词检查列（留空检查整行）',
  'pages.flexibleSingleImport.filter.checkColumnsPlaceholder': '选择列；不选则检查整行',
  'pages.flexibleSingleImport.sample.head': '数据区开头样例',
  'pages.flexibleSingleImport.sample.tail': '数据区末尾样例',
  'pages.flexibleSingleImport.row.number': '行号',
  'pages.flexibleSingleImport.row.content': '内容',
  'pages.flexibleSingleImport.row.reason': '处理',
  'pages.flexibleSingleImport.row.suspiciousSummary': '已排除的行',
  'pages.flexibleSingleImport.row.excludeRestore': '排除/恢复',
  'pages.flexibleSingleImport.row.excluded': '已排除',
  'pages.flexibleSingleImport.row.keep': '保留',
  'pages.flexibleSingleImport.mapping.targetField': '目标字段',
  'pages.flexibleSingleImport.mapping.source': '来源',
  'pages.flexibleSingleImport.mapping.chooseTarget': '映射到目标字段',
  'pages.flexibleSingleImport.mapping.chooseSource': '选择来源',
  'pages.flexibleSingleImport.mapping.step2MissingTitle': '还有 {count} 个必填字段未关联',
  'pages.flexibleSingleImport.mapping.step2MissingDescription':
    '请在上方每列的下拉框中选择对应的目标字段：',
  'pages.flexibleSingleImport.mapping.step2CompleteTitle': '必填字段已全部关联',
  'pages.flexibleSingleImport.mapping.step2CompleteDescription':
    '可以完成第二步，进入已排除的行检查。',
  'pages.flexibleSingleImport.mapping.step2MappedLabel': '已关联的必填字段：',
  'pages.flexibleSingleImport.mapping.advancedTitle': '第四步 · 设置未对应的必填字段',
  'pages.flexibleSingleImport.mapping.advancedHint':
    '这里支持固定值、子表名称或文件名。如果字段每行都不同且原表没有对应列，请修改原表后重新上传。',
  'pages.flexibleSingleImport.mapping.requiredMissing': '以下必填字段还没有对应',
  'pages.flexibleSingleImport.mapping.requiredMissingDescription':
    '这里只能设置整张子表共用的值。如果每一行都不同且没有来源列，请先把原表改正确后重新上传。',
  'pages.flexibleSingleImport.mapping.requiredComplete': '目前必填字段都已经对应',
  'pages.flexibleSingleImport.mapping.requiredCompleteDescription':
    '如果某个缺少的值每行都不同，不要在这里猜测，请修改原表后重新上传。',
  'pages.flexibleSingleImport.mapping.parameter': '固定值/参数',
  'pages.flexibleSingleImport.mapping.transform': '转换',
  'pages.flexibleSingleImport.mapping.columnFallback': '第 {column} 列',
  'pages.flexibleSingleImport.mapping.fixedPlaceholder': '输入固定值',
  'pages.flexibleSingleImport.mapping.regexPlaceholder': '正则，例如 (\\d{4}-\\d{2})',
  'pages.flexibleSingleImport.mapping.datePlaceholder': '支持 yyyy-MM-dd、yyyy/MM、yyyy 或自动识别',
  'pages.flexibleSingleImport.mapping.configuringSheet': '正在配置子表：',
  'pages.flexibleSingleImport.mapping.regenerate': '重新生成建议映射',
  'pages.flexibleSingleImport.mapping.suggestionAlert':
    '建议映射只作为起点，请确认必填字段和收入字段后再预览。',
  'pages.flexibleSingleImport.mapping.previewFailed': '映射预览失败',
  'pages.flexibleSingleImport.field.required': '必填',
  'pages.flexibleSingleImport.field.saleMonth': '销售月份（日期）',
  'pages.flexibleSingleImport.field.platform': '平台',
  'pages.flexibleSingleImport.field.country': '国家/地区',
  'pages.flexibleSingleImport.field.isrcNumber': 'ISRC/歌曲ID',
  'pages.flexibleSingleImport.field.releaseType': '发行类型',
  'pages.flexibleSingleImport.field.saleType': '销售类型',
  'pages.flexibleSingleImport.field.songTitle': '歌曲名',
  'pages.flexibleSingleImport.field.currency': '货币',
  'pages.flexibleSingleImport.field.unitPrice': '单价',
  'pages.flexibleSingleImport.field.netProfit': '净收入',
  'pages.flexibleSingleImport.field.reportMonth': '报告月',
  'pages.flexibleSingleImport.field.brandName': '品牌名称',
  'pages.flexibleSingleImport.field.artistName': '艺人名称',
  'pages.flexibleSingleImport.field.publishTitle': '发行标题',
  'pages.flexibleSingleImport.field.upcNumber': 'UPC',
  'pages.flexibleSingleImport.field.publishListNumber': '发行目录编号',
  'pages.flexibleSingleImport.field.streamSubscriptionType': '流式订阅类型',
  'pages.flexibleSingleImport.field.saleNumber': '数量',
  'pages.flexibleSingleImport.field.machineryCosts': '机械费',
  'pages.flexibleSingleImport.field.totalIncome': '总收入',
  'pages.flexibleSingleImport.field.customerShareRate': '客户分享率',
  'pages.flexibleSingleImport.field.albumName': '专辑名称',
  'pages.flexibleSingleImport.field.playCount': '播放量',
  'pages.flexibleSingleImport.source.column': '普通列',
  'pages.flexibleSingleImport.source.sheetName': '子表名称',
  'pages.flexibleSingleImport.source.fileName': '文件名',
  'pages.flexibleSingleImport.source.fixed': '固定值',
  'pages.flexibleSingleImport.transform.none': '不转换',
  'pages.flexibleSingleImport.transform.trim': '去空格',
  'pages.flexibleSingleImport.transform.regex': '正则提取',
  'pages.flexibleSingleImport.transform.date': '日期转换',
  'pages.flexibleSingleImport.transform.number': '数字转换',
  'pages.flexibleSingleImport.transform.integer': '整数转换',
  'pages.flexibleSingleImport.transform.percent': '百分比转换',
  'pages.flexibleSingleImport.preview.title': '预览结果',
  'pages.flexibleSingleImport.preview.description':
    '系统已按每个子表的数据区和排除规则重新扫描，只有点击确认后才会写入 sales_list。',
  'pages.flexibleSingleImport.preview.sheet': '子表',
  'pages.flexibleSingleImport.preview.consideredRows': '参与处理',
  'pages.flexibleSingleImport.preview.excludedRows': '排除',
  'pages.flexibleSingleImport.preview.validRows': '有效',
  'pages.flexibleSingleImport.preview.invalidRows': '错误',
  'pages.flexibleSingleImport.preview.view': '查看',
  'pages.flexibleSingleImport.preview.samples': '样例',
  'pages.flexibleSingleImport.preview.mappingSamples': '映射样例',
  'pages.flexibleSingleImport.preview.rawValues': '原始值',
  'pages.flexibleSingleImport.preview.mappedValues': '转换后',
  'pages.flexibleSingleImport.preview.errorCount': '该子表有 {count} 行校验错误',
  'pages.flexibleSingleImport.preview.partialWarning':
    '发现 {count} 行错误，合法数据仍可以继续导入。',
  'pages.flexibleSingleImport.preview.partialWarningDescription':
    '请查看下面的错误明细。错误行不会写入本次导入结果，完成导入后仍可以下载错误行。',
  'pages.flexibleSingleImport.preview.errorTitle':
    '该子表有 {count} 行错误，下面显示前 {shown} 条。',
  'pages.flexibleSingleImport.preview.errorDescription':
    '每条错误都包含原始行号、可读的错误原因和原始数据中的关键值。',
  'pages.flexibleSingleImport.preview.errorReason': '错误原因',
  'pages.flexibleSingleImport.preview.errorSource': '原始行关键值',
  'pages.flexibleSingleImport.result.processed': '处理行',
  'pages.flexibleSingleImport.result.inserted': '新增',
  'pages.flexibleSingleImport.result.duplicates': '重复',
  'pages.flexibleSingleImport.result.errors': '错误',
  'pages.flexibleSingleImport.result.exportErrors': '下载错误行',
  'pages.flexibleSingleImport.import.startFailed': '启动导入失败',
  'pages.flexibleSingleImport.status.UPLOADED': '已上传，等待配置',
  'pages.flexibleSingleImport.status.READY': '配置完成，等待确认',
  'pages.flexibleSingleImport.status.IMPORTING': '导入中',
  'pages.flexibleSingleImport.status.COMPLETED': '导入完成',
  'pages.flexibleSingleImport.status.PARTIAL': '部分完成',
  'pages.flexibleSingleImport.status.FAILED': '导入失败',
  'pages.flexibleSingleImport.status.CANCELLED': '已取消',
  'pages.flexibleSingleImport.action.cancel': '取消',
  'pages.flexibleSingleImport.action.importSheet': '导入这个子表',
  'pages.flexibleSingleImport.action.skipSheet': '不导入这个子表',
  'pages.flexibleSingleImport.action.previousStep': '上一步',
  'pages.flexibleSingleImport.action.editStep': '修改',
  'pages.flexibleSingleImport.action.finishStep2': '完成第 2 步，继续检查已排除的行',
  'pages.flexibleSingleImport.action.finishStep3': '完成第 3 步，继续补齐未对应字段',
  'pages.flexibleSingleImport.action.finishSheet': '完成本子表，进入下一个子表',
  'pages.flexibleSingleImport.action.finishLastSheet': '完成本子表，预览所有已导入子表',
  'pages.flexibleSingleImport.action.nextMapping': '下一步：字段对齐',
  'pages.flexibleSingleImport.action.previousSheet': '上一个子表',
  'pages.flexibleSingleImport.action.nextSheet': '下一个子表',
  'pages.flexibleSingleImport.action.previewAll': '预览所有已导出子表',
  'pages.flexibleSingleImport.action.backToSheets': '返回子表检查',
  'pages.flexibleSingleImport.action.abandonImport': '放弃上传',
  'pages.flexibleSingleImport.action.continueImport': '继续导入合法数据',
  'pages.flexibleSingleImport.action.previous': '上一步',
  'pages.flexibleSingleImport.action.previewMapping': '预览映射和校验',
  'pages.flexibleSingleImport.action.backEdit': '返回修改',
  'pages.flexibleSingleImport.action.confirmImport': '确认导入',
  'pages.flexibleSingleImport.action.close': '关闭',
};
